module.exports = __webpack_public_path__ + "static/media/folkradio.99427796.png";